import { computed } from "vue";

import { useAuthenticationStore } from "@/store/authentication.store";

import type { Ref } from "vue";

export const useGlobalOrganisationID = () => {
  const authStore = useAuthenticationStore();
  const selectedMsp = computed(() => authStore.selectedMsp);
  const selectedCustomer = computed(() => authStore.selectedCustomer);
  const selectedAccount = computed(() => authStore.selectedAccount);

  const mspGlobalOrganisationId: Ref<string | null> = computed(
    () => selectedMsp.value?.uuid || selectedAccount.value?.uuid || null,
  );
  const customerGlobalOrganisationId: Ref<string | null> = computed(
    () => selectedCustomer.value?.uuid || selectedAccount.value?.uuid || null,
  );

  return {
    mspGlobalOrganisationId,
    customerGlobalOrganisationId,
  };
};

export default {};
